import gql from "graphql-tag";

export const MY_LEAVE_USERS_WITH_REQUEST = gql`
  mutation usersWithRequest(
    $roleFilters: RoleFilterInput
    $onlyRequested: Boolean
    $sortField: String
    $sortDirection: String
    $searchField: String
    $searchText: String
    $showRemoteWorks: Boolean
    $role: String
    $startDate: Date
    $endDate: Date
    $page: Int
    $pageSize: Int
  ) {
    usersWithRequest(
      roleFilters: $roleFilters
      onlyRequested: $onlyRequested
      sortField: $sortField
      sortDirection: $sortDirection
      searchField: $searchField
      searchText: $searchText
      showRemoteWorks: $showRemoteWorks
      role: $role
      startDate: $startDate
      endDate: $endDate
      page: $page
      pageSize: $pageSize
    ) {
      rows {
        contract
        employee
        name
        orgUnit
        jobClass
        allLeavesCount
        pastRequestedLeavesCount
        currentRequestedLeavesCount
        futureRequestedLeavesCount
        _id
      }
      total
      page
      pageSize
      totalPages
      allLeavesCount
      allUsersCount
    }
  }
`;
